<template>
  <FormCustomQuery
    :loadingSave="loadingSave"
    :errorMessageSave="errorMessageSave"
    :saveCustomQuery="saveCustomQuery"
    :customQuery="customQuery"
  />
</template>

<script type="ts">
import { defineComponent } from 'vue';
import FormCustomQuery from '../Form/template.vue';
import useCreateQuery from '../../composables/useCreateQuery';

export default defineComponent({
  name: 'CustomQueryNew',
  components: {
    FormCustomQuery,
  },
  setup() {
    const {
      loadingSave,
      errorMessageSave,
      saveCustomQuery,
      customQuery,
    } = useCreateQuery();
    return {
      loadingSave,
      errorMessageSave,
      saveCustomQuery,
      customQuery,
    };
  },
});
</script>
